<template lang="pug">
.check-container(v-if="show")
  .shadow(@click="closeModal")
  .check-block
    .close-icon(@click="closeModal")
    .check-top
      img.check-sign(src="https://m.hellobike.com/resource/gallery/61/kCyeyPnmkc.png?x-oss-process=image/quality,q_80")
      .check-line 会员特权已使用，不可退
    .cbeck-bottom
      .bottom-title 特权使用详情
      .bottom-list(v-for="(item,index) in useVipDetails")
        .bottom-list-item
          .bottom-list-useSign
            .bottom-list-useSign-word 已使用
          .bottom-list-word
            .bottom-list-word-one {{ item.privilegeType }}
            .bottom-list-word-two {{ item.privilegeDetail }}
      .check-btn
        .check-btn-left(@click="checkRule") 查看规则
        .check-btn-right(@click="closeModal") 我知道了
  </template>
<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { Navigator } from '@hb/h5-navigator';

export default {
  components: {
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    useVipDetails: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      useList: [{}],
    };
  },
  destroyed() {
  },
  created() {
  },
  methods: {
    closeModal() {
      this.$emit('update:show', false);
    },
    checkRule() {
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_Equity_used',
        categoryId: 'platform',
        businessInfo: {},
      });
      Navigator.go('https://m.hellobike.com/mf/spa/u_jsawic/latest/MA2112242694445671692369920.html?activityCode=MA2112242694445671692369920', { isRuleLink: true });
      this.$emit('update:show', false);
    },
  },
};
</script>
<style lang="less" scoped>

.check-container {
  position: fixed;
  bottom: 0;
  z-index: 222;
  width: 100%;

  .shadow {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: #000;
    opacity: 0.7;
    z-index: 100;
  }

  .check-block {
    background: linear-gradient(180deg, #f6f7f7 0%, #fff 100%);
    border-radius: 0.2rem 0.2rem 0 0;
    position: relative;
    z-index: 223;
    min-height: 2.95rem;
    padding: 0 0.12rem;

    .close-icon {
      position: absolute;
      background-image: url(https://m.hellobike.com/resource/helloyun/15979/HP3T5BQrkn.png);
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 0.16rem;
      height: 0.16rem;
      top: 0.12rem;
      right: 0.12rem;
    }

    .check-top {
      display: flex;
      justify-content: center;
      padding-top: 0.3rem;

      img.check-sign {
        width: 0.24rem;
        height: 0.24rem;
        margin-right: 0.06rem;
      }

      .check-line {
        font-family: PingFangSC, PingFang SC, sans-serif;
        font-weight: 500;
        font-size: 0.2rem;
        color: #242729;
        line-height: 0.28rem;
      }
    }

    .cbeck-bottom {
      margin-top: 0.28rem;
      background: linear-gradient(180deg, #fff 0%, rgba(255, 255, 255, 0) 100%);
      border-radius: 0.2rem;

      .bottom-title {
        padding: 0.2rem 0 0 0.2rem;
        font-family: PingFangSC, PingFang SC, sans-serif;
        font-weight: 500;
        font-size: 0.16rem;
        color: #242729;
        margin-bottom: 0.14rem;
      }

      .bottom-list-item {
        display: flex;
        padding: 0 0.2rem;
        margin-bottom: 0.08rem;

        .bottom-list-useSign {
          font-family: PingFangSC, PingFang SC, sans-serif;
          font-weight: 400;
          font-size: 0.11rem;
          color: #f72626;
          line-height: 0.18rem;
          text-align: center;
          margin-right: 0.08rem;

          .bottom-list-useSign-word {
            width: 0.42rem;
            height: 0.18rem;
            background: #fee9e9;
            border-radius: 0.04rem;
          }
        }

        .bottom-list-word {
          font-family: PingFangSC, PingFang SC, sans-serif;
          font-weight: 400;
          font-size: 0.14rem;
          color: #242729;

          .bottom-list-word-two {
            font-family: PingFangSC, PingFang SC, sans-serif;
            font-weight: 400;
            font-size: 0.12rem;
            color: #879099;
            margin-top: 0.05rem;
          }
        }
      }

      .check-btn {
        display: flex;
        justify-content: space-between;
        margin-top: 0.38rem;
        margin-bottom: 0.1rem;

        .check-btn-left {
          width: 1.68rem;
          height: 0.48rem;
          background: #f3f3f4;
          border-radius: 0.08rem;
          text-align: center;
          font-family: PingFangSC, PingFang SC, sans-serif;
          font-weight: 400;
          font-size: 0.18rem;
          color: #242729;
          line-height: 0.48rem;
        }

        .check-btn-right {
          width: 1.59rem;
          height: 0.48rem;
          background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
          text-align: center;
          font-family: PingFangSC, PingFang SC, sans-serif;
          font-weight: 500;
          font-size: 0.18rem;
          color: #fff;
          line-height: 0.48rem;
          border-radius: 0.08rem;
        }
      }
    }
  }
}
</style>
